import React, { FC } from 'react'
import { QuestionProps } from '../types'
import { BaseTrainedQuestion } from './base-trained-question'

export const KnowledgeQuestion: FC<QuestionProps> = props => {
  return (
    <BaseTrainedQuestion {...props} questionLabel="Question" answerLabel="Answer" layout="horizontal" />
  )
}
